import React from 'react';
import { motion, HTMLMotionProps } from 'framer-motion';
import { tapSpring, hoverLift } from '../../components/shared/motionPresets';
import { soundManager } from '../../utils/soundManager';
import { hapticManager } from '../../utils/hapticManager';
interface CardSurfaceProps extends Omit<HTMLMotionProps<'button'>, 'onClick'> {
  isDisabled?: boolean;
  disableDefaultSound?: boolean;
  onClick?: () => void;
  children: React.ReactNode;
  className?: string;
}
export function CardSurface({
  isDisabled = false,
  disableDefaultSound = false,
  onClick,
  children,
  className = '',
  ...props
}: CardSurfaceProps) {
  const handleTap = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (!isDisabled && onClick) {
      if (!disableDefaultSound) {
        soundManager.playClick();
      }
      hapticManager.hapticLight();
      onClick();
    }
  };
  return <motion.button type="button" disabled={isDisabled} onClick={handleTap} {...!isDisabled ? hoverLift : {}} {...!isDisabled ? tapSpring : {}} animate={isDisabled ? {
    x: [0, -1, 1, -1, 0]
  } : props.animate} transition={isDisabled ? {
    duration: 0.6,
    repeat: Infinity,
    repeatDelay: 3.5,
    ease: 'easeInOut'
  } : props.transition} className={`relative text-left ${className}`} {...props} data-id="element-2771">
      {children}
    </motion.button>;
}